module.exports = require("./qu");